import Form from 'src/utils/Form.js'

class User extends Form {
    constructor(data, config = null) {
        super(data, config || Form.config)
    }

    register(then) {
        return super.post('/register').then(({user}) => {
            this.originalData = user
            this.originalData['password'] = '';
            for (let field in user) {
                if (field === 'mobile') {
                    this[field] = user[field].replace(/\s/g, "")
                } else {
                    this[field] = user[field];
                }
            }
            then(user)
        });
    }

    sendVerificationEmail(then) {
        return super.post('/send/verification/email').then(then)
    }

    changePassword(then) {
        return super.post('auth/change/password').then(then)
    }
}

export default User
